import { Components } from '@mui/material';
import React from 'react';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';

export const checkbox: Components = {
  MuiCheckbox: {
    defaultProps: {
      checkedIcon: React.createElement(CheckBoxOutlinedIcon),
    },
    styleOverrides: {
      root: ({ ownerState }) => ({
        color: ownerState.checked ? '#00C0B4' : '#66798D',
        // backgroundColor: ownerState.checked ? '#FFFFFF' : 'transparent',
        '&:hover': {
          backgroundColor: ownerState.checked
            ? 'transparent'
            : 'rgba(102, 121, 141, 0.04)',
        },
        '& .MuiSvgIcon-root': {
          // Ensure the SVG icon (border/checkmark) uses the correct color
          color: ownerState.checked ? '#00C0B4' : '#66798D',
        },
      }),
    },
  },
};
